// Connection to the V2 API
import axios from 'axios';
import store from '../../store';

const HttpV2 = axios.create({
  baseURL: process.env.VUE_APP_V2_REST_API,
});

const V2_API_AUTH_HEADER = 'ACQUIRE-LEGACY-DASHBOARD-ACCESS-KEY';
const V2_API_USER_AUTH_HEADER = "ACQUIRE-LEGACY-AUTH-ID";

HttpV2.interceptors.request.use((config) => {
  config.headers[V2_API_AUTH_HEADER] = process.env.VUE_APP_V2_REST_API_KEY;
  config.headers[V2_API_USER_AUTH_HEADER] = store.getters.getUser.id;
  return config;
});

export default HttpV2;
